module.exports = __webpack_public_path__ + "img/rekrutacja-1050x630.1acd8d78.jpg";